import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ol>
      <li parentName="ol">
        <p parentName="li"><inlineCode parentName="p">{`person_profiles: 'always'`}</inlineCode>{` `}<em parentName="p">{`(default)`}</em>{` - We capture person profiles for all events.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li"><inlineCode parentName="p">{`person_profiles: 'identified_only'`}</inlineCode>{` `}<em parentName="p">{`(recommended)`}</em>{` - We only capture person profiles for users where they are already created. This is triggered by calling functions like `}<inlineCode parentName="p">{`identify()`}</inlineCode>{`, `}<inlineCode parentName="p">{`group()`}</inlineCode>{`, and `}<a parentName="p" {...{
            "href": "/docs/product-analytics/identify#processing-person-profiles"
          }}>{`more`}</a>{`. New anonymous users won't get person profiles.`}</p>
      </li>
    </ol>
    <p>{`An example of an updated configuration looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js-web"
      }}>{`posthog.init(
    '<ph_project_api_key>',
    {
        api_host: '<ph_client_api_host>',
        person_profiles: 'identified_only'
    }
)
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      